import { render, staticRenderFns } from "./GoodsComponent.vue?vue&type=template&id=6f88a6a0&"
import script from "./GoodsComponent.vue?vue&type=script&lang=js&"
export * from "./GoodsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports